import GetTenantId from '/src/_includes/authentication/get-tenant-id.md';
import IMSAuth from '/src/_includes/authentication/initial-auth-for-api-access.md';
import GetBearerToken from '/src/_includes/authentication/initial-auth-for-api-access.md';
import * as React from 'react';
export default {
  GetTenantId,
  IMSAuth,
  GetBearerToken,
  React
};